import React from "react";
import clsx from "clsx";
import { Box, Card, makeStyles, Typography, Button } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import parse from "html-react-parser";
import Grid from "@material-ui/core/Grid";
import { NavLink as RouterLink } from "react-router-dom";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import LinkIcon from "@material-ui/icons/Link";
import KmFormPreviewTable from "src/components/common/KmFormPreviewTable";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  newstext: {
    "& > ol, & > ul": {
      marginLeft: theme.spacing(4),
    },
  },
  titlebox: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: 400,
  },
  imagebox: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  gallerybox: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
}));

const attachmentCols = [
  {
    label: "L.p.",
    isLp: true,
    isEditable: false,
    width: "5%",
  },
  {
    label: "Typ",
    fieldName: "type",
    isEditable: false,
    width: "15%",
  },
  {
    label: "Plik/Odnośnik",
    fieldName: "details",
    isEditable: false,
    width: "65%",
    isHtml: true,
  },
  {
    label: "Rozmiar pliku",
    fieldName: "fileSize",
    isEditable: false,
    width: "15%",
  },
];

const Form = ({ news, ...rest }) => {
  const classes = useStyles();

  const images = news?.images
    ? news.images.map((image) => {
        return {
          original: `${news.imagesBaseUrl}${image.fileName}`,
          thumbnail: `${news.imagesBaseUrl}${image.fileName}`,
        };
      })
    : [];

  const attachments = news?.attachments
    ? news.attachments.map((attachment) => {
        return attachment.type === "file"
          ? {
              type: <InsertDriveFileIcon />,
              details: `<a target="blank" href="${news.attachmentsBaseUrl}${attachment.fileName}">${attachment.description}</a>`,
              fileSize: attachment.fileSize,
            }
          : attachment.type === "url"
          ? {
              type: <LinkIcon />,
              details: `<a target="blank" href="${attachment.urlValue}">${attachment.urlLabel}</a>`,
              fileSize: null,
            }
          : null;
      })
    : [];

  const getReturnUrl = () => {
    if (news) {
      if (news.status === "draft") {
        return "/aktualnosci/wersjerob";
      } else if (news.status === "published") {
        return "/aktualnosci/opublikowane";
      } else if (news.status === "archived") {
        return "/aktualnosci/archiwum";
      }
    }
    return "/aktualnosci/wersjerob";
  };

  return (
    <Card className={clsx(classes.root)} {...rest}>
        <Box component="main">
          <Box className={classes.titlebox}>
            {news ? (
              <div>
                <KmPageTitle>
                  {news.title}
                </KmPageTitle>
                {news.publishedAt ? <Typography
                  variant="subtitle2"
                  component="span"
                  className={classes.title}
                >
                  Opublikowano {news.publishedAt}
                </Typography>:<></>}
              </div>
            ) : (
              <Skeleton />
            )}
          </Box>

          {/* {news?.image ? (
            <Grid container spacing={2} className={classes.imagebox}>
              <Grid item xs sm={2}></Grid>
              <Grid item xs={12} sm={8}>
                <img
                  className={classes.img}
                  alt={`Zdjęcie do ${news.title}`}
                  src={`${news.imagesBaseUrl}${news.image}`}
                />
              </Grid>
              <Grid item xs sm={2}></Grid>
            </Grid>
          ) : (
            <></>
          )} */}
          <Box>
            {news ? (
              <Typography component="div" className={classes.newstext}>
                {parse(news.content)}
              </Typography>
            ) : (
              <Skeleton />
            )}
          </Box>
          {images?.length > 0 ? (
            <Box>
              <Grid container spacing={2} className={classes.gallerybox}>
                <Grid item xs sm={2.5}></Grid>
                <Grid item xs={12} sm={7}>
                  <ImageGallery items={images} />
                </Grid>
                <Grid item xs sm={2.5}></Grid>
              </Grid>
            </Box>
          ) : (
            <></>
          )}
          {attachments?.length > 0 ? (
            <Box>
              <Grid container spacing={2} className={classes.gallerybox}>
                <Grid item xs sm={2}></Grid>
                <Grid item xs={12} sm={8}>
                  <KmFormPreviewTable
                    columns={attachmentCols}
                    rows={attachments}
                  />
                </Grid>
                <Grid item xs sm={2}></Grid>
              </Grid>
            </Box>
          ) : (
            <></>
          )}
          <Box className={classes.paddingtop}>
            <Button
              color="primary"
              className={classes.button}
              component={RouterLink}
              to={getReturnUrl()}
            >
              Powrót
            </Button>
          </Box>
        </Box>
    </Card>
  );
};

export default Form;
